import { j as a } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as e } from "react";
const o = e(
  ({ className: s = "", ordered: i = !1, children: t, ...r }, d) => i ? /* @__PURE__ */ a.jsx(
    "ol",
    {
      ref: d,
      className: `rds-list ${s}`,
      "data-testid": "rds-list--ordered",
      ...r,
      children: t
    }
  ) : /* @__PURE__ */ a.jsx(
    "ul",
    {
      ref: d,
      className: `rds-list ${s}`,
      "data-testid": "rds-list--unordered",
      ...r,
      children: t
    }
  )
);
o.displayName = "List";
export {
  o as L
};
